import PageTemplate from "../../components/templates/PageTemplate";
import FaqsPage from "../../components/support/faqs_page";
import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";
import faqJson from "../../../content/faq/faq.json";
import type { SupportCategory } from "@/v2-components/pages/support/types/support-data";
import { findFirstLeaf } from "@/v2-components/pages/support/utils/help-center-utils";

type FaqCategory = (typeof faqJson)["categories"][number];

function buildFaqTree(categories: FaqCategory[]): SupportCategory {
  function convert(cat: FaqCategory): SupportCategory {
    const children = cat.children?.map((c) => convert(c));
    return {
      id: cat.id,
      label: cat.label,
      ...(children?.length ? { children } : {}),
    };
  }

  return {
    id: "faq",
    label: "FAQ",
    children: categories.map((c) => convert(c)),
  };
}

export default function FaqPage({ faqData }) {
  return (
    <PageTemplate>
      <PageTemplate.Content>
        <FaqsPage faqData={faqData} />
      </PageTemplate.Content>
    </PageTemplate>
  );
}
export async function getServerSideProps({ locale }) {
  const lang = locale ?? "en";
  const { categories, posts } = faqJson;

  const faqTree = buildFaqTree(categories);
  const firstLeaf = findFirstLeaf(faqTree)?.id ?? "orders";

  const resolvedPosts = posts.map((p) => ({
    id: p.id,
    category: p.category,
    title: p.title[lang] ?? p.title.en ?? "",
    content: p.content[lang] ?? p.content.en ?? "",
  }));

  return {
    props: {
      ...(await serverSideTranslations(locale, ["support", "index", "gnb"])),
      faqData: {
        faqTree,
        firstCategorySlug: firstLeaf,
        posts: resolvedPosts,
      },
    },
  };
}
